import React from 'react';
import { LdFeld, LdUmschalter } from '../../components/ld/LdFenster';

// Welle B4: „Attest gleich mitfragen“ — nur bei aktiver Attestpflicht. Vorgabe „Noch nicht“
// (= wie bisher „Attest offen“); „Ja“ speichert das Attest, die Fehlzeit ist dann entschuldigt.
// Gefragt wird bei jeder Fehlzeit des Kindes: „Attest fehlt“ zählt seit U3c jede Fehlzeit
// ohne Attest ab Beginn der Attestpflicht.
export function AttestFrage({ attest, onChange }: { attest: boolean; onChange: (ja: boolean) => void }) {
  return (
    <LdFeld label="Attestpflicht aktiv. Liegt ein Attest vor?">
      <LdUmschalter aria-label="Liegt ein Attest vor?" wert={attest ? 'ja' : 'nein'} onChange={w => onChange(w === 'ja')}
        optionen={[{ wert: 'ja', label: 'Ja' }, { wert: 'nein', label: 'Noch nicht' }]} />
    </LdFeld>
  );
}
